/**
 * StatCard Component
 *
 * Displays a labeled statistic in a card format.
 */

import { DevCardBadge } from "./DevCardBadge";

export interface StatCardProps {
  label: string;
  value: number | string;
}

export function StatCard({ label, value }: StatCardProps) {
  return (
    <DevCardBadge name="StatCard">
      <div className="bg-gray-50 dark:bg-zinc-800/50 rounded-lg p-3 text-center">
        <span className="text-xs text-gray-500 dark:text-gray-400 block">{label}</span>
        <span className="text-2xl font-bold font-accent text-zinc-900 dark:text-white">{value}</span>
      </div>
    </DevCardBadge>
  );
}
